import {
  LOAD_PREFERENCIAS,
  UPDATE_PREFERENCIAS,
  RESET_PREFERENCIAS
} from './preferencias-constants';

import {
  PREFERENCIAS_DEFAULTS
} from './preferencias-defaults';

import {
  loadPreferencesFromStorage,
  savePreferencesToStorage,
  normalizePreferences
} from './preferencias-helper';

const INITIAL_STATE = {
  preferencias: {},
  loaded: false,
};

export default function preferenciasReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case LOAD_PREFERENCIAS: {
      const stored = loadPreferencesFromStorage();

      const preferencias = normalizePreferences(
        PREFERENCIAS_DEFAULTS,
        stored
      );

      savePreferencesToStorage(preferencias);

      return {
        ...state,
        preferencias,
        loaded: true,
      };
    }

    case UPDATE_PREFERENCIAS: {
      const newPrefs = {
        ...state.preferencias,
        [action.payload.key]: action.payload.value,
      };

      savePreferencesToStorage(newPrefs);

      return {
        ...state,
        preferencias: newPrefs,
      };
    }

    case RESET_PREFERENCIAS: {
      const defaults = normalizePreferences(PREFERENCIAS_DEFAULTS);
      savePreferencesToStorage(defaults);

      return {
        ...state,
        preferencias: defaults,
      };
    }

    default:
      return state;
  }
}
